module.exports = require("@swa-ui/authentication/src/components/BaseAuthenticationForm/BaseAuthenticationForm.module.scss");